import React from "react";

function Hamburger() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      fill="none"
      viewBox="0 0 35 35"
    >
      <g filter="url(#filter0_b_270_8)">
        <mask id="path-1-inside-1_270_8" fill="#fff">
          <path
            fillRule="evenodd"
            d="M27 0H0v28l6 7h29V7l-8-7zm-9.49 19.469a1 1 0 000-2H9a1 1 0 100 2h8.51zM24.168 12a1 1 0 01-1 1H9a1 1 0 110-2h14.169a1 1 0 011 1zm2.233 13.938a1 1 0 100-2H9a1 1 0 100 2h17.402z"
            clipRule="evenodd"
          ></path>
        </mask>
        <path
          fill="#000"
          fillRule="evenodd"
          d="M27 0H0v28l6 7h29V7l-8-7zm-9.49 19.469a1 1 0 000-2H9a1 1 0 100 2h8.51zM24.168 12a1 1 0 01-1 1H9a1 1 0 110-2h14.169a1 1 0 011 1zm2.233 13.938a1 1 0 100-2H9a1 1 0 100 2h17.402z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#1D1D1D"
          fillOpacity="0.1"
          fillRule="evenodd"
          d="M27 0H0v28l6 7h29V7l-8-7zm-9.49 19.469a1 1 0 000-2H9a1 1 0 100 2h8.51zM24.168 12a1 1 0 01-1 1H9a1 1 0 110-2h14.169a1 1 0 011 1zm2.233 13.938a1 1 0 100-2H9a1 1 0 100 2h17.402z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#80FF00"
          d="M0 0v-.5h-.5V0H0zm27 0l.33-.376-.142-.124H27V0zM0 28h-.5v.185l.12.14L0 28zm6 7l-.38.325.15.175H6V35zm29 0v.5h.5V35H35zm0-28h.5v-.227l-.17-.15L35 7zM0 .5h27v-1H0v1zm.5 8V0h-1v8.5h1zM.5 28V8.5h-1V28h1zm5.88 6.675l-6-7-.76.65 6 7 .76-.65zM26.5 34.5H6v1h20.5v-1zm8.5 0h-8.5v1H35v-1zm-.5-8V35h1v-8.5h-1zm0-19.5v19.5h1V7h-1zM26.67.376l8 7 .66-.752-8-7-.66.752zM18.01 18.47a.5.5 0 01-.5.5v1a1.5 1.5 0 001.5-1.5h-1zm-.5-.5a.5.5 0 01.5.5h1a1.5 1.5 0 00-1.5-1.5v1zm-8.51 0h8.51v-1H9v1zm-.5.5a.5.5 0 01.5-.5v-1a1.5 1.5 0 00-1.5 1.5h1zm.5.5a.5.5 0 01-.5-.5h-1a1.5 1.5 0 001.5 1.5v-1zm8.51 0H9v1h8.51v-1zm5.659-5.469a1.5 1.5 0 001.5-1.5h-1a.5.5 0 01-.5.5v1zM9 13.5h14.169v-1H9v1zM7.5 12A1.5 1.5 0 009 13.5v-1a.5.5 0 01-.5-.5h-1zM9 10.5A1.5 1.5 0 007.5 12h1a.5.5 0 01.5-.5v-1zm14.169 0H9v1h14.169v-1zm1.5 1.5a1.5 1.5 0 00-1.5-1.5v1a.5.5 0 01.5.5h1zm2.233 12.938a.5.5 0 01-.5.5v1a1.5 1.5 0 001.5-1.5h-1zm-.5-.5a.5.5 0 01.5.5h1a1.5 1.5 0 00-1.5-1.5v1zM9 24.438h17.402v-1H9v1zm-.5.5a.5.5 0 01.5-.5v-1a1.5 1.5 0 00-1.5 1.5h1zm.5.5a.5.5 0 01-.5-.5h-1a1.5 1.5 0 001.5 1.5v-1zm17.402 0H9v1h17.402v-1z"
          mask="url(#path-1-inside-1_270_8)"
        ></path>
      </g>
      <defs>
        <filter
          id="filter0_b_270_8"
          width="44.333"
          height="44.333"
          x="-4.667"
          y="-4.667"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feGaussianBlur
            in="BackgroundImageFix"
            stdDeviation="2.333"
          ></feGaussianBlur>
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_270_8"
          ></feComposite>
          <feBlend
            in="SourceGraphic"
            in2="effect1_backgroundBlur_270_8"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
}

export default Hamburger;